import { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import dateFormat from 'dateformat';

import styles from '@components/Tickets/TicketsTable.module.css';

import {
  BootstrapTable,
  BootstrapVerticalColumnTable,
} from '@components/Table/Table';

const renderActionsCell = ({ row }) => {
  const navigate = useNavigate();
  return (
    <Button
      className="btn-sm"
      variant="didxl"
      onClick={() => navigate(`/tickets/details/${row.values.ticketID}/`)}
    >
      Details
    </Button>
  );
};

const renderMissingCellValue = ({ value }) => value || '-';

const ticketListingColumns = [
  {
    id: 'ticketID',
    Header: 'Ticket ID',
    accessor: 'id',
    className: 'col-md-1',
  },
  {
    id: 'tracker',
    Header: 'Tracker',
    accessor: 'type',
    className: 'col-md-1',
    Cell: renderMissingCellValue,
  },
  {
    id: 'status',
    Header: 'Status',
    accessor: 'status',
    className: 'col-md-1',
  },
  {
    id: 'subject',
    Header: 'Subject',
    accessor: 'subject',
    className: 'col-md-5',
  },
  {
    id: 'ticket_type',
    Header: 'Ticket Type',
    accessor: 'ticket_type',
    className: 'col-md-1',
    Cell: renderMissingCellValue,
  },
  {
    id: 'created',
    Header: 'Created',
    accessor: 'created_at',
    className: 'col-md-1',
    Cell: ({ value }) => {
      const date = new Date(value);
      return dateFormat(date, 'defaultDateTime');
    },
  },
  {
    id: 'updated',
    Header: 'Updated',
    accessor: 'updated_at',
    className: 'col-md-1',
    Cell: ({ value }) => {
      const date = new Date(value);
      return dateFormat(date, 'defaultDateTime');
    },
  },
  {
    id: 'action',
    Header: 'Action',
    className: 'col-md-1',
    Cell: renderActionsCell,
  },
];

export const OpenTicketsTable = ({ data }) => (
  <BootstrapTable
    columns={ticketListingColumns}
    data={data}
    tableProps={() => ({ responsive: true, bordered: true })}
  />
);

export const ClosedTicketsTable = ({ data }) => (
  <BootstrapTable
    columns={ticketListingColumns}
    data={data}
    tableProps={() => ({ responsive: true, bordered: true })}
  />
);

const renderDescription = ({ value }) => (
  <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>
);

export const TicketDetailsTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Subject',
        accessor: 'subject',
      },
      {
        Header: 'Created',
        accessor: 'created_at',
        Cell: ({ value }) => {
          const date = new Date(value);
          return dateFormat(date, 'defaultDateTime');
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'DID(s)',
        accessor: 'dids',
        Cell: renderMissingCellValue,
      },
      {
        Header: 'Country',
        accessor: 'country',
        Cell: renderMissingCellValue,
      },
      {
        Header: 'Ticket Type',
        accessor: 'ticket_type',
        Cell: renderMissingCellValue,
      },
      {
        Header: 'Author',
        accessor: 'author',
      },
      {
        Header: 'Description',
        accessor: 'description',
        Cell: renderDescription,
      },
    ],
    []
  );

  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={[data]}
      tableProps={() => ({
        responsive: true,
        bordered: false,
        className: styles.table,
      })}
    />
  );
};
